// apps/dashboard/src/routes/sign-in.tsx
import { createFileRoute, redirect } from "@tanstack/react-router";
import { SignIn } from "@clerk/react";
import { AuthShell } from "@/components/chrome/AuthShell";

export const Route = createFileRoute("/sign-in")({
  staticData: { shell: "auth" },
  beforeLoad: () => {
    const clerk = (globalThis as {
      Clerk?: { user?: unknown; session?: { status?: string } };
    }).Clerk;
    // Stay on /sign-in for pending sessions so Clerk's <SignIn> can
    // render the choose-organization task UI.
    if (clerk?.user && clerk.session?.status !== "pending") {
      throw redirect({ to: "/dashboard" });
    }
  },
  component: SignInPage,
});

function SignInPage() {
  return (
    <AuthShell>
      <SignIn
        routing="hash"
        forceRedirectUrl="/dashboard"
        signUpUrl="/sign-up"
      />
    </AuthShell>
  );
}
